const CLIENT_ENDPOINTS = {
    //  BASE Routes
    ROOT: '/',
    DISCUSSIONS: '/discussions',
    SCHEDULE: '/schedule',
    CATALOG: '/catalog',
    SYSTEM: '/system',
    SETTINGS: '/settings',
    PROFILE: '/profile',
    PROGRESS: '/progress',
    REPORTS: '/reports',
    REPORT: '/reports/:reportId',
    REFLECTION_PROMPTS: '/reflection-prompts',
    REFLECTION_PROMPT: '/reflection-prompts/:reflectionPromptId',
    LOCATIONS: '/locations',
    LOCATION: '/locations/:locationId',
    EXPERIENCES: '/experiences',
    EXPERIENCE: '/experiences/:experienceId',
    MOBILE: '/mobile',
    MOBILE_IOS: '/mobile/ios',
    MOBILE_ANDROID: '/mobile/android',

    USERS: '/users',
    USER: '/users/:userId',
    USERS_CREATE: '/users/new',

    MESSAGES: '/messages',
    //  Allow messaging from any route.  We will use query params to communicate intent
    MESSAGE_CREATE: '/:any*/message',
    REPORTS: '/reports',

    LEARNING_RESOURCES: '/learning/resources',
    LEARNING_RESOURCE: '/learning/resources/:resourceId',

    //  Instances
    USER_GOAL: '/goals/:goalId',
    USER_REFLECTION: '/users/:userId/reflections/:promptId',

    //  Modifiers
    NEW: '/new',
    EDIT: '/edit',
    VIEW: '/view',
    DUPLICATE: '/duplicate',
    ATTENDANCE: '/attendance',
    ENROLLMENT: '/enrollment',
    MESSAGE: '/message',
    DROP: '/drop',
    ENROLL: '/enroll',
    PREVIEW_SCHEDULE: '/schedule',
    CONFLICTS: '/conflicts'
    
}

export default CLIENT_ENDPOINTS
